import React, {Component} from 'react';
import Modal from "react-modal";

Modal.setAppElement('#root');

class Alert extends Component{
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.isOpen !== nextProps.isOpen
            || this.props.message !== nextProps.message
            || this.props.buttons !== nextProps.buttons
        )
    }

    render() {
        const { isOpen, handleClose, message, buttons } = this.props;

        return (
            <Modal isOpen={isOpen} onRequestClose={handleClose} className={"react-modal"} overlayClassName="modal-overlay">
                <div className='modal-header justify-content-end'>
                    <button className='btn btn-close' onClick={handleClose}/>
                </div>
                <div className='modal-body'>
                    <span style={{whiteSpace: "pre-wrap"}}>{message}</span>
                </div>
                <div className='modal-footer'>
                    {
                        buttons.map((button, index) => {
                            return <button className={button.className} key={index} onClick={button.onClick}>{button.label}</button>
                        })
                    }
                </div>
            </Modal>
        )
    }
}

export default Alert;
